module.exports = __webpack_public_path__ + "img/terry-gallery-3.6341ae52.jpg";